import ListBenefits from './views/List.vue'
import CreateEditBenefit from './views/CreateEdit.vue'
import GetBenefit from './views/Get.vue'

export const BenefitRoutes = [
  {
    path: '/benefits',
    name: 'ListBenefits',
    component: ListBenefits,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'benefit:list'
    }
  },
  {
    path: '/benefit',
    name: 'CreateBenefit',
    component: CreateEditBenefit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'benefit:create'
    }
  },
  {
    path: '/benefit/:id',
    name: 'UpdateBenefit',
    component: CreateEditBenefit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'benefit:update'
    }
  },
  {
    path: '/benefit/view/:id',
    name: 'GetBenefit',
    component: GetBenefit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'benefit:get'
    }
  }
]
